import { useReducer } from 'react';

// Helper function to create deep copies
const deepCopy = <T>(data: T): T => {
    return JSON.parse(JSON.stringify(data));
};

export default function useFlowStore() {
    const [flow, dispatch] = useReducer(flowReducer, []);

    const loadFlow = (flow: any) => {
        dispatch({ type: actions.LOAD, payload: flow });
    };

    const addStep = (step: any) => {
        dispatch({ type: actions.ADD_STEP, payload: step });
    };

    const removeStep = (index: number) => {
        dispatch({ type: actions.REMOVE_STEP, payload: index });
    };

    const updateStep = (step: any) => {
        dispatch({ type: actions.UPDATE_STEP, payload: step });
    };

    const moveStep = (from: number, to: number) => {
        dispatch({ type: actions.MOVE_STEP, payload: { from, to } });
    };

    return {
        flow,
        loadFlow,
        addStep,
        removeStep,
        updateStep,
        moveStep,
    };
}

const actions = {
    LOAD: 'LOAD',
    ADD_STEP: 'ADD_STEP',
    REMOVE_STEP: 'REMOVE_STEP',
    UPDATE_STEP: 'UPDATE_STEP',
    MOVE_STEP: 'MOVE_STEP',
};

type FlowAction = {
    type: string;
    payload: any;
};

const flowReducer = (state: any = [], action: FlowAction) => {
    switch (action.type) {
        case actions.LOAD:
            // Create a deep copy of the entire flow
            return deepCopy(action.payload);

        case actions.ADD_STEP:
            // Create a deep copy of the state and the new step
            return [...deepCopy(state), deepCopy(action.payload)];

        case actions.REMOVE_STEP:
            // Create a new array without the removed step
            return state.filter(
                (_step: any, index: number) => index !== action.payload,
            );

        case actions.MOVE_STEP:
            // Create a deep copy of the state before moving
            console.log('MOVE_STEP', action.payload);
            const newState = deepCopy(state);
            const [removed] = newState.splice(action.payload.from, 1);
            newState.splice(action.payload.to, 0, removed);
            return newState;

        case actions.UPDATE_STEP:
            // Create a deep copy of the state and update the specific step
            return state.map((step: any, index: number) => {
                if (index === action.payload.index) {
                    return deepCopy(action.payload.stepObject);
                }
                return deepCopy(step);
            });

        default:
            return state;
    }
};
